// 供应商自主注册
// 社会信用代码及手机号校验
export const API_POST_SELF_REGISTER_CHECK = {
  url: 'self/register/check',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 注册提交/编辑提交
export const API_POST_SELF_REGISTER_SUBMIT = {
  url: 'self/register/submit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 获取供应商注册信息
export const API_POST_SELF_REGISTER_INFO = {
  url: 'self/register/info',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 联行号搜索
export const API_POST_SELF_REGISTER_LINKBANKSEARCH = {
  url: 'self/register/linkBankSearch',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 上传图片
export const API_POST_SELF_REGISTER_UPLOAD_FILE = {
  url: 'self/register/upload/file',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 彩食鲜联系人
export const API_POST_SELF_REGISTER_USER_LIST = {
  url: 'self/register/user/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 身份证证件上传
export const API_POST_SELF_REGISTER_ID_FILE = {
  url: 'self/register/id/file',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**  获取信用&违法声明模板 */
export const API_GET_XINYONG_OR_WEIFA_EXAMPLE_FILE = {
  url: 'templates/信用&违法声明模板.docx',
  config: {
    method: 'get',
    host: 'CAISX_MDM',
  },
};
